var React = require('react');

function GooglePlay (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m6.15 2.328 10.276 10.7 3.038-3.163c-5.235-2.96-12.158-6.877-13.314-7.537zm-2.967.677a2.146 2.146 0 0 0 -.183.856v22.281a1.988 1.988 0 0 0 .143.716l11.475-11.947zm18.624 8.188-3.573 3.718 3.545 3.689 3.683-2.086a1.924 1.924 0 0 0 1.006-1.666 1.882 1.882 0 0 0 -1.008-1.594zm-5.381 5.6-10.199 10.62c1.756-1 8.244-4.674 13.21-7.485z","fill":"#fff","transform":"translate(-3 -2.328)"}));
}

GooglePlay.defaultProps = {"height":"25.085","viewBox":"0 0 23.468 25.085","width":"23.468"};

module.exports = GooglePlay;

GooglePlay.default = GooglePlay;
